/*
 * EnvAuthenticatorStepTwo Messages
 *
 * This contains all the text for the EnvAuthenticatorStepTwo component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.EnvAuthenticatorStepTwo";

export default defineMessages(scope, {
  codeTextField: "Enter Code",
  backButtonLabel: "Back to QR Code",
  verifyButtonLabel: "Verify",
  cancelButtonLabel: "Cancel",
  invalidCodeErrorMessage: "Incorrect code. Please try again.",
});
